import { DateTime } from 'luxon';
import { AuditAction } from '../enums/audit-action.enum';
import { AuditResource } from '../enums/audit-resource.enum';

export const AUDIT_RECORD_MEDIA_TYPE = 'application/vnd.io.idaas.admin.api.audit.record.v1+json';

export class AuditRecord {
  public timestamp: DateTime;
  public actor: string;
  public resourceType: AuditResource;
  public resourceId: string;
  public resourceRealmName: string;
  public action: AuditAction;
  public note: string;

  constructor(backEndAuditRecord?: BackEndAuditRecord) {
    if (backEndAuditRecord) {
      this.timestamp = DateTime.fromISO(backEndAuditRecord.timestamp);
      this.actor = backEndAuditRecord.actor;
      this.resourceType = backEndAuditRecord.resource_type;
      this.resourceId = backEndAuditRecord.resource_id;
      this.resourceRealmName = backEndAuditRecord.resource_realm_name;
      this.action = backEndAuditRecord.action;
      this.note = backEndAuditRecord.note;
    }
  }
}

export interface BackEndAuditRecord {
  timestamp: string;
  actor: string;
  resource_type: AuditResource;
  resource_id: string;
  resource_realm_name: string;
  action: AuditAction;
  note: string;
}
